import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

/**
 * One-tap switch between English and Nepali.
 *
 * The button shows the language you would switch TO, in that language's own
 * script - someone who only reads Nepali can still find it on an English page.
 */
function LanguageToggle({ className = '', showLabel = true }) {
  const { language, toggleLanguage, languages } = useLanguage();
  const next = language === 'ne' ? languages.en : languages.ne;

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      title={`Switch to ${next.name} / ${next.nativeName} मा बदल्नुहोस्`}
      aria-label={`Switch to ${next.name}`}
      className={`flex items-center gap-1.5 px-2 py-1.5 min-h-[36px] text-sm font-medium text-gray-600 hover:text-cafe-700 hover:bg-cafe-50 rounded-lg transition-colors flex-shrink-0 ${className}`}
    >
      <Languages className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
      {showLabel && <span className="whitespace-nowrap">{next.nativeName}</span>}
    </button>
  );
}

export default LanguageToggle;
